/**
 * @generated SignedSource<<cf5576e0897648e8aa23220da7d050cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveUserFromAccountInput = {
  accountId: string;
  clientMutationId?: string | null;
  userId: string;
};
export type usersInAccountTable_RemoveUserFromAccountMutation$variables = {
  connections: ReadonlyArray<string>;
  input: RemoveUserFromAccountInput;
};
export type usersInAccountTable_RemoveUserFromAccountMutation$data = {
  readonly Admin: {
    readonly Auth: {
      readonly removeUserFromAccount: {
        readonly removedUserId: string;
      } | null;
    };
  };
};
export type usersInAccountTable_RemoveUserFromAccountMutation = {
  response: usersInAccountTable_RemoveUserFromAccountMutation$data;
  variables: usersInAccountTable_RemoveUserFromAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedUserId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usersInAccountTable_RemoveUserFromAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "RemoveUserFromAccountPayload",
                "kind": "LinkedField",
                "name": "removeUserFromAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usersInAccountTable_RemoveUserFromAccountMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "RemoveUserFromAccountPayload",
                "kind": "LinkedField",
                "name": "removeUserFromAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "removedUserId",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "331fe40eb06fa2cad7161b391c9760d9",
    "id": null,
    "metadata": {},
    "name": "usersInAccountTable_RemoveUserFromAccountMutation",
    "operationKind": "mutation",
    "text": "mutation usersInAccountTable_RemoveUserFromAccountMutation(\n  $input: RemoveUserFromAccountInput!\n) {\n  Admin {\n    Auth {\n      removeUserFromAccount(input: $input) {\n        removedUserId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e267359f69d1cc7e0a0c9a0e52832fa";

export default node;
